
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start/flow",
      function () {
        return require("private-next-pages/start/flow/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/start/flow"])
      });
    }
  